// Tree.js code
// This function generates a random tree.
function generateTree(idx, num) {
  if (num === 1) {
    return { id: idx, children: [] };
  } else {
    let split = 1 + Math.floor((num - 1) * Math.random());
    return {
      id: idx + split,
      children: [
        generateTree(idx, split),
        generateTree(idx + split + 1, num - split),
      ],
    };
  }
}

class Tree {
  constructor(opts) {
    this.root = opts.root;
    this.strokeWidth = opts.strokeWidth;
    this.treeSize = opts.treeSize;
    this.d3Tree = d3.tree().size([this.treeSize * 1.2, this.treeSize * 1]);
    this.root = d3.hierarchy(this.root, (d) => d.children);
    this.treeData = this.d3Tree(this.root);
  }

  // This method draws a simple tree in desinated g element
  drawTree(svgLocation) {
    let rScale = d3.scaleSequential().domain([0, 1]).range([0, 4]);
    // draw links
    const cell = svgLocation;
    const treePaths = cell
      .append("g")
      .attr("class", "tree-link-g")
      .selectAll("path")
      .data(this.treeData.links())
      .join("path")
      .attr(
        "d",
        d3
          .linkVertical()
          .x((d) => d.x)
          .y((d) => d.y)
      )
      .attr("class", "link")
      .attr("fill", "#354848")
      .attr("stroke", "#354848")
      .attr("stroke-width", 0.75 * this.strokeWidth);

    // draw nodes
    const treeNodes = cell
      .append("g")
      .attr("class", "tree-node-g")
      .selectAll("rect")
      .data(this.treeData.descendants());
    const rectSize = rScale(this.treeSize / 29);
    const treeCircles = treeNodes
      .join("rect")
      .attr("fill", "rgb(206, 56, 116)")
      .attr("height", rectSize)
      .attr("width", rectSize)
      .attr("rx", 1)
      .attr("ry", 1)
      .attr("x", (d) => d.x - rectSize / 2)
      .attr("y", (d) => d.y - rectSize / 2)
      .attr("stroke", "#354848")
      .attr("stroke-width", this.strokeWidth / 2);
  }
  // This method draws a tree in desinated g element with the colors for RF scrolly.
  drawTreeWithText(svgLocation) {
    // draw links
    const cell = svgLocation;
    this.treeElement = svgLocation;
    const treePaths = cell
      .append("g")
      .attr("class", "tree-link-g")
      .selectAll("path")
      .data(this.treeData.links())
      .join("path")
      .attr(
        "d",
        d3
          .linkVertical()
          .x((d) => d.x)
          .y((d) => d.y)
      )
      .attr("id", (d, i) => `link${i}`)
      .attr("feature", (d) => d.source.data.name)
      .attr("boundary", (d) => d.source.data.value)
      .attr("order", (d, i) => `${d.source.data.id}-${i % 2}`)
      .attr("opacity", 0)
      .attr("class", "link")
      .attr("fill", "none")
      .attr("stroke", "#354848")
      .attr("stroke-width", this.strokeWidth);

    // draw nodes
    const treeNodes = cell
      .append("g")
      .attr("class", "tree-node-g")
      .selectAll("rect")
      .data(this.treeData.descendants());
    const rectHeight = this.treeSize / 10;
    const rectWidth = (d) => ("name" in d ? rectHeight : 0);
    let classNames = ["No", "Yes"];
    if (window.innerWidth < 600) classNames = ["N", "Y"];
    let fontSize = `${this.treeSize / 15}px`;
    if (window.innerWidth < 600) fontSize = `${this.treeSize / 7}px`;
    const textAccessor = (d) => ("name" in d ? "" : classNames[d.class]);
    const treeCircles = treeNodes
      .join("rect")
      .attr("class", "nodes")
      .attr("opacity", 0)
      .attr("fill", (d) => d.data.color)
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("x", (d) => d.x - rectWidth(d.data) / 2)
      .attr("y", (d) => d.y)
      .attr("height", rectHeight)
      .attr("width", (d) => rectWidth(d.data))
      .attr("stroke", "#232f3e")
      .attr("stroke-width", this.strokeWidth / 2);

    const treeText = treeNodes
      .join("text")
      .attr("text-anchor", "middle")
      .attr("class", "nodetexts")
      .attr("alignment-baseline", "middle")
      .attr("transform", (d) => `translate(${d.x},${d.y + this.treeSize / 20})`)
      .attr("font-size", fontSize)
      .attr("fill", "black")
      .attr("opacity", 0)
      .text((d) => textAccessor(d.data));
  }
  //For bar-code, "yes" "no" is removed b/c it's impossible to read!!
  drawBarcodeTree(svgLocation) {
    // draw links
    const cell = svgLocation;
    this.treeElement = svgLocation;
    const treePaths = cell
      .append("g")
      .attr("class", "tree-link-g")
      .selectAll("path")
      .data(this.treeData.links())
      .join("path")
      .attr(
        "d",
        d3
          .linkVertical()
          .x((d) => d.x)
          .y((d) => d.y)
      )
      .attr("id", (d, i) => `link${i}`)
      .attr("feature", (d) => d.source.data.name)
      .attr("boundary", (d) => d.source.data.value)
      .attr("order", (d, i) => `${d.source.data.id}-${i % 2}`)
      .attr("opacity", 1)
      .attr("class", "link")
      .attr("fill", "none")
      .attr("stroke", "#354848")
      .attr("stroke-width", this.strokeWidth);

    // draw nodes
    const treeNodes = cell
      .append("g")
      .attr("class", "tree-node-g")
      .selectAll("rect")
      .data(this.treeData.descendants());
    const rectHeight = this.treeSize / 8;
    const rectWidth = (d) => ("name" in d ? rectHeight : 0);
    const classNames = ["N", "Y"];
    const fontSize = `0.6rem`;
    const textAccessor = (d) => ("name" in d ? "" : classNames[d.class]);
    const treeCircles = treeNodes
      .join("rect")
      .attr("class", "nodes")
      .attr("opacity", 1)
      .attr("fill", (d) => d.data.color)
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("x", (d) => d.x - rectWidth(d.data) / 2)
      .attr("y", (d) => d.y)
      .attr("height", rectHeight)
      .attr("width", (d) => rectWidth(d.data))
      .attr("stroke", "#232f3e")
      .attr("stroke-width", this.strokeWidth);

    const treeText = treeNodes
      .join("text")
      .attr("text-anchor", "middle")
      .attr("class", "nodetexts")
      .attr("alignment-baseline", "middle")
      .attr("transform", (d) => `translate(${d.x},${d.y + this.treeSize / 10})`)
      .attr("font-size", fontSize)
      .attr("fill", "#232f3e")
      .attr("opacity", 1)
      .text((d) => textAccessor(d.data));
  }
  // This method draws a tree in desinated g element with the colors for RF scrolly tree building.
  drawTreeWithSplit(svgLocation) {
    const color1 = ["#feeca9", "#005da3", "#ce3874"]; //S, C, T
    const color1ID = [false, true, false]; //false = unselected feature, true = selected feature
    const color2 = ["#feeca9", "#e99f46", "#ce3874"]; //S, N, T
    const color2ID = [false, false, true]; //ID for color1
    const colors = [color1, color2];
    // draw links
    const cell = svgLocation;
    const treePaths = cell
      .append("g")
      .attr("class", "tree-link-g")
      .selectAll("path")
      .data(this.treeData.links())
      .join("path")
      .attr(
        "d",
        d3
          .linkVertical()
          .x((d) => d.x)
          .y((d) => d.y)
      )
      .attr("class", (d, i) => (i < 4 ? `link-${i}` : "splitlink"))
      .attr("fill", "none")
      .attr("stroke", "#354848")
      .attr("stroke-width", this.strokeWidth)
      .attr("opacity", 0);

    // draw nodes
    const treeNodes = cell
      .append("g")
      .attr("class", "tree-node-g-split")
      .selectAll("rect")
      .data(this.treeData.descendants());

    const rectHeight = this.treeSize / 10;
    const rectWidth = (d) => ("name" in d ? rectHeight : 0);
    let classNames = ["No", "Yes"];
    if (window.innerWidth < 600) classNames = ["N", "Y"];
    let fontSize = `${this.treeSize / 15}px`;
    if (window.innerWidth < 600) fontSize = `${this.treeSize / 10}px`;
    const textAccessor = (d) => ("name" in d ? "" : classNames[d.class]);
    const splitNode = (d) => ("split" in d ? true : false);
    const splitnodeLocations = [];
    const treeCircles = treeNodes
      .join("rect")
      .attr("fill", (d) => d.data.color)
      .attr("rx", 2)
      .attr("ry", 2)
      //Below, for the nodes that shows the split, we store the location information to use it later.
      .attr("id", (d, i) => {
        if (splitNode(d.data)) {
          splitnodeLocations.push([d.x, d.y]);
          return `split${i}`;
        } else return "rest";
      })
      .attr("x", (d) => d.x - rectWidth(d.data) / 2)
      .attr("y", (d) => d.y)
      .attr("height", rectHeight)
      .attr("width", (d) => rectWidth(d.data))
      .attr("stroke", "#232f3e")
      .attr("stroke-width", this.strokeWidth)
      .attr("opacity", 0);
    const addSplitNodes = d3
      .select("g.tree-node-g-split")
      .append("g")
      .selectAll("rect")
      .data(Array.from({ length: 6 })); //There are 6 features to show for the split

    addSplitNodes
      .join("rect")
      .attr("fill", (d, i) => colors[Math.floor(i / 3)][i % 3])
      .attr("class", (d, i) => `splitnode${Math.floor(i / 3)}`)
      .attr("rx", 2)
      .attr("ry", 2)
      .attr(
        "x",
        (d, i) =>
          splitnodeLocations[Math.floor(i / 3)][0] -
          1.5 * rectHeight +
          (i % 3) * rectHeight
      )
      .attr("y", (d, i) => splitnodeLocations[Math.floor(i / 3)][1])
      .attr("height", rectHeight)
      .attr("width", rectHeight)
      .attr("stroke", "#232f3e")
      .attr("stroke-width", this.strokeWidth)
      .attr("opacity", 0);
    const treeText = treeNodes
      .join("text")
      .attr("text-anchor", "middle")
      .attr("class", "splitnodetexts")
      .attr("alignment-baseline", "middle")
      .attr("transform", (d) => `translate(${d.x},${d.y + this.treeSize / 20})`)
      .attr("font-size", fontSize)
      .attr("fill", "black")
      .attr("opacity", 0)
      .text((d) => textAccessor(d.data));
  }
}

// Grid.js code
class Grid {
  constructor(opts) {
    this.chartContainer = opts.chartContainer;
    this.nCell = 5;
    this.strokeWidth = 1;
    this.numTrees = this.nCell * this.nCell;
    this.maxDepth = opts.maxDepth;
    this.trees = [];
    this.size = Math.min(
      d3.select(this.chartContainer).node().getBoundingClientRect().height,
      d3.select(this.chartContainer).node().getBoundingClientRect().width
    );
    this.squareSize = this.size / (1.7 * this.nCell);
    this.initializeTrees();
    this.makeGrid();
    this.treesToDisplay = 0;
    this.drawTreesOnGrid(this.treesToDisplay);
  }
  initializeTrees() {
    let treeIndex = 0;
    for (treeIndex = 0; treeIndex < this.numTrees; treeIndex++) {
      this.trees.push(
        new Tree({
          root: generateTree(0, this.maxDepth),
          treeSize: this.squareSize * 1.2,
          strokeWidth: this.strokeWidth,
        })
      );
    }
  }
  makeGrid() {
    let sel = d3
      .select(this.chartContainer)
      .append("svg")
      .attr("class", "grid")
      .attr("width", this.size)
      .attr("height", this.size);

    const scale = d3
      .scaleLinear()
      .domain([0, this.nCell - 1])
      .range([0, this.size]);

    const join = sel.selectAll("circle").data(d3.range(this.numTrees));

    join
      .enter()
      .append("g")
      .attr("class", (d, i) => `grid-tree-${i}`)
      .attr("transform", (d, i) => {
        const nx = i % this.nCell;
        const n = Math.floor(i / this.nCell);
        return `translate(${(this.size / this.nCell) * nx},${
          (this.size / this.nCell) * n + this.size * 0.02
        })`;
      })
      .merge(join);
  }

  drawTreesOnGrid(numTreeToDisplay) {
    this.treesToDisplay = numTreeToDisplay;
    let sliceTrees = this.trees.slice(0, numTreeToDisplay);
    let sel = d3.select(this.chartContainer);
    let j = 0;
    for (j = numTreeToDisplay; j < this.numTrees; j++) {
      sliceTrees.push(null);
    }
    sel
      .selectAll("g")
      .data(sliceTrees)
      .each((d, i) => {
        sel.select(`g.grid-tree-${i}`).selectAll("g").remove();
        if (d != null) d.drawTree(sel.select(`g.grid-tree-${i}`));
      });
  }

  resizeChart() {
    // Below is computationally inefficient but creates a chart that positions correctly upon resizing.
    let vis = this;
    this.size = Math.min(
      d3.select(this.chartContainer).node().getBoundingClientRect().height,
      d3.select(this.chartContainer).node().getBoundingClientRect().width
    );
    this.squareSize = this.size / (1.7 * this.nCell);
    d3.select(vis.chartContainer).selectAll("svg.grid").remove();
    this.makeGrid();
    let i = 0;
    for (i = 0; i < this.numTrees; i++) {
      this.trees[i].treeSize = this.squareSize * 1.2;
      this.trees[i].d3Tree.size([this.squareSize * 1.2, this.squareSize * 1.2]);
      this.trees[i].root = d3.hierarchy(this.trees[i].root, (d) => d.children);
      this.trees[i].treeData = this.trees[i].d3Tree(this.trees[i].root);
    }
    this.drawTreesOnGrid(this.treesToDisplay);
  }
}

// Scatter.js code
function nCr(a, n) {
  let pascal = [
    [],
    [1],
    [],
    [1, 3],
    [],
    [1, 5, 10],
    [],
    [1, 7, 21, 35],
    [],
    [1, 9, 36, 84, 126],
    [],
    [1, 11, 55, 165, 330, 462],
    [],
    [1, 13, 78, 286, 715, 1287, 1716],
    [],
    [1, 15, 105, 455, 1365, 3003, 5005, 6435],
    [],
    [1, 17, 136, 680, 2380, 6188, 12376, 19448, 24310],
    [],
    [1, 19, 171, 969, 3876, 11628, 27132, 50388, 75582, 92378],
    [],
    [1, 21, 210, 1330, 5985, 20349, 54264, 116280, 203490, 293930, 352716],
    [],
    [
      1, 23, 253, 1771, 8855, 33649, 100947, 245157, 490314, 817190, 1144066,
      1352078,
    ],
    [],
    [
      1, 25, 300, 2300, 12650, 53130, 177100, 480700, 1081575, 2042975, 3268760,
      4457400, 5200300,
    ],
  ];
  return pascal[a][n];
}

class Scatter {
  constructor(opts) {
    this.chartContainer = opts.chartContainer;
    this.strokeWidth = 1;
    this.width = d3
      .select(this.chartContainer)
      .node()
      .getBoundingClientRect().width;
    this.height = d3
      .select(this.chartContainer)
      .node()
      .getBoundingClientRect().height;
    this.prob = 0.6;
    this.data = [];
    this.numDots = 0;
    this.dataUpdate(this.prob);
    this.makeScatter();
    this.drawDots(this.numDots);
  }
  dataUpdate(prob) {
    this.prob = prob;
    this.data = [];
    let j = 0;
    let f = 1 - prob;
    for (j = 1; j < 26; j = j + 2) {
      let p = Math.pow(f, j);
      let k = 1;
      for (k = 1; k < j / 2; k++) {
        p = p + nCr(j, k) * Math.pow(f, j - k) * Math.pow(prob, k);
      }
      this.data.push([j, 1 - p]);
    }
  }
  makeScatter() {
    let vis = this;
    let padding = 40;

    //Create scale functions
    let xScale = d3
      .scaleLinear()
      .domain([0, 25])
      .range([padding, vis.width - padding / 2]);

    let yScale = d3
      .scaleLinear()
      .domain([0, 1])
      .range([vis.height - padding, padding / 2]);

    //Define X axis
    let xAxis = d3
      .axisBottom()
      .scale(xScale)
      .tickSize(0)
      .tickSizeOuter(0)
      .ticks(5);

    //Define Y axis
    let yAxis = d3
      .axisLeft()
      .scale(yScale)
      .tickSize(-this.width)
      .tickSizeOuter(0)
      .ticks(6)
      .tickFormat((x) => `${d3.format(".0%")(x)}`);

    const containerDims = d3
      .select(this.chartContainer)
      .node()
      .getBoundingClientRect();

    //Create SVG element
    let svg = d3
      .select(vis.chartContainer)
      .append("svg")
      .attr("class", "scatter")
      .attr("width", containerDims.width)
      .attr("height", containerDims.height);

    //Create X axis
    svg
      .append("g")
      .attr("class", "axis")
      .attr("id", "x-axis")
      .attr("transform", "translate(0," + (vis.height - padding) + ")")
      .style("font-size", this.width / 40)
      .style("color", "#354848")
      .call(xAxis);

    //Create Y axis
    svg
      .append("g")
      .attr("class", "axis")
      .attr("id", "y-axis")
      .attr("transform", "translate(" + padding + ",0)")
      .style("font-size", this.height / 20)
      .style("color", "#354848")
      .call(yAxis);

    // add text labels
    svg
      .append("text")
      .attr("class", "scatter-axis-text")
      .attr("x", this.width / 2)
      .attr("y", this.height)
      .attr("dy", -padding / 6)
      .attr("text-anchor", "middle")
      .text("Ensemble Accuracy by Tree Count");
    svg
      .append("text")
      .attr("class", "scatter-axis-text")
      .attr("x", -this.height / 2)
      .attr("y", -50)
      .attr("text-anchor", "middle")
      .text("Price, in USD")
      .attr("transform", "rotate(-90)");

    //Create circles
    const circle = svg.selectAll("circle").data(vis.data);

    const circleG = circle
      .enter()
      .append("g")
      .attr("transform", (d) => `translate(${xScale(d[0])}, ${yScale(d[1])})`);

    circleG
      .append("circle")
      .attr("class", (d, i) => "circle-" + i)
      .attr("r", 0)
      .style("fill", "rgb(254, 236, 169)")
      .attr("stroke", "black")
      .attr("stroke-width", 1)
      .attr("fill-opacity", 1);

    circleG
      .append("text")
      .attr("class", "percent")
      .text((d) =>
        window.innerWidth < 700
          ? d3.format(".1f")(d[1])
          : d3.format(".2f")(d[1])
      )
      .attr("y", window.innerWidth < 700 ? "-5px" : "-.5rem")
      .attr("font-size", window.innerWidth < 700 ? ".3rem" : ".5rem")
      .attr("text-anchor", "middle");
  }

  drawDots(numDotsToDisplay) {
    this.numDots = numDotsToDisplay;
    let sliceTrees = this.data.slice(0, numDotsToDisplay);
    let j = 0;
    for (j = numDotsToDisplay; j < 25; j++) {
      sliceTrees.push(null);
    }
    let aScale = d3.scaleLinear().domain([0, 1]).range([1, 13]);
    let padding = 30;
    let vis = this;
    let sel = d3.select(this.chartContainer);
    sel
      .selectAll("svg.scatter")
      .selectAll("circle")
      .data(sliceTrees)
      .attr("r", (d) => {
        if (d != null) return aScale(vis.width / 1000);
        else return 0;
      });

    sel
      .selectAll("svg.scatter")
      .selectAll("text.percent")
      .data(sliceTrees)
      .attr("visibility", (d) => {
        if (d != null) return "visible";
        else return "hidden";
      });
  }

  // TODO: This can be more efficient by making sure axis are drawn only once.
  circleUpdate(newProb) {
    let vis = this;
    vis.prob = newProb;
    vis.dataUpdate(newProb);
    d3.select(vis.chartContainer).selectAll("svg.scatter").remove();
    this.makeScatter();
  }
  resizeChart() {
    let vis = this;
    this.width = d3
      .select(this.chartContainer)
      .node()
      .getBoundingClientRect().width;
    this.height = d3
      .select(this.chartContainer)
      .node()
      .getBoundingClientRect().height;
    this.dataUpdate(this.prob);
    d3.select(vis.chartContainer).selectAll("svg.scatter").remove();
    this.makeScatter();
    this.drawDots(this.numDots);
  }
}

// index.js code
let numTreeslider = "#numSlider";
let probSlider = "#probSlider";
const treeGrid = new Grid({
  chartContainer: "#gridOfTrees",
  maxDepth: 5,
});

const scatterPlot = new Scatter({
  chartContainer: "#scatter",
});

// list of sections for intersection observer to track
const sectionsCondurcet = d3.selectAll("section.condurcet-scrolly").nodes();

// options for intersection observer
const options = {
  threshold: 0.7,
};
d3.select("#chart-wrapper-condurcet").style("opacity", 1);
// dict for target events
const target2event = {
  0: () => {
    d3.select("#numSlider").property("value", "1");
    treeGrid.drawTreesOnGrid(1);
    scatterPlot.drawDots(1);
    d3.select("#numTrees-value").html(`# of Trees: 1`);
    // ensure sliders hidden
    d3.selectAll("#numSlider").style("opacity", 0);
    d3.selectAll("#probSlider").style("opacity", 0);
  },
  1: () => {
    d3.select("#numSlider").property("value", "3");
    treeGrid.drawTreesOnGrid(3);
    scatterPlot.drawDots(2);
    d3.select("#numTrees-value").html(`# of Trees: 3`);
    // ensure sliders hidden
    d3.selectAll("#numSlider").style("opacity", 0);
    d3.selectAll("#probSlider").style("opacity", 0);
  },
  2: () => {
    d3.select("#numSlider").property("value", "11");
    treeGrid.drawTreesOnGrid(11);
    scatterPlot.drawDots(6);
    d3.select("#numTrees-value").html(`# of Trees: 11`);
    // ensure sliders hidden
    d3.selectAll("#numSlider").style("opacity", 0);
    d3.selectAll("#probSlider").style("opacity", 0);
  },
  3: () => {
    treeGrid.drawTreesOnGrid(25);
    scatterPlot.drawDots(Math.floor(25 / 2) + 1);
    d3.select("#numSlider").property("value", "25");
    d3.select("#numTrees-value").html(`# of Trees: 25`);
    // show sliders
    d3.selectAll("#numSlider").style("opacity", 1);
    d3.selectAll("#probSlider").style("opacity", 1);
  },
  4: () => {},
};

let observer = new IntersectionObserver(trackScroll, options);

function trackScroll(entries) {
  entries.forEach((entry) => {
    // check if visible or not
    if (entry.isIntersecting) {
      // resolve stage in graph
      const entryIndex = entry.target.getAttribute("data-index");
      if (entryIndex in target2event) {
        target2event[entryIndex]();
      }
    }
  });
}

sectionsCondurcet.forEach((section) => {
  observer.observe(section);
});

// Handle Condurcet input slider events
d3.select(numTreeslider).on("input", function (d) {
  let val = d3.select(this).property("value");
  treeGrid.drawTreesOnGrid(val);
  scatterPlot.drawDots(Math.floor(val / 2) + 1);
  d3.select("#numTrees-value").html(`# of Trees: ${val}`);
});
d3.select(probSlider).on("input", function (d) {
  let val = d3.select(this).property("value");
  scatterPlot.circleUpdate(val);
  scatterPlot.drawDots(
    Math.ceil(d3.select(numTreeslider).property("value") / 2)
  );

  d3.select("#probability-value").html(
    `Tree Accuracy: ${d3.format(".0%")(val)}`
  );
});
// generic window resize listener event
// don't trigger for mobile
const resize = (window.onresize = () => {
  if (window.innerWidth >= 1000) {
    scatterPlot.resizeChart();
    treeGrid.resizeChart();
  }
});
window.addEventListener("resize", resize);